module.exports = __webpack_public_path__ + "img/step.b5aeaf61.png";